export default __webpack_public_path__ + "images/referenzen/animationsfilm/philips_prograde.mp4";